import {Directive, effect, Injector, input, OnInit, TemplateRef, ViewContainerRef} from '@angular/core';
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {BrukerkontekstTilbyder} from "felles-ng2/tjenester/BrukerkontekstTilbyder";
import {GruppeId, TilgangsrolleMedlem} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {enumInnslag} from "felles-ng2/støttefunksjoner/enumer";

const debug = initDebugger('KreverTilgangsrolleGruppeDirektiv');

type TilgangsrolleMedlemNavn = keyof typeof TilgangsrolleMedlem;

/**
 * Rendrer elementet dersom bruker har angitt {@link TilgangsrolleMedlem}.
 *
 * Bruk: <span *kreverTilgangsrolleGruppe="'navn_på_rolle'; gruppeId:gruppe.id">
 */
@Directive({
    selector: '[kreverTilgangsrolleGruppe]',
})
class KreverTilgangsrolleGruppeDirektiv implements OnInit{

    //første parameter har samme navn som direktivet
    rolle = input.required<TilgangsrolleMedlemNavn>({alias:'kreverTilgangsrolleGruppe'})

    //for strukturelle direktiver må ekstra parametere (utenom det første) prefikses med direktiv-navnet
    gruppeId = input.required<GruppeId>({alias:'kreverTilgangsrolleGruppeGruppeId'})

    private viewOpprettet = false;

    constructor(private kontekst:BrukerkontekstTilbyder, private injector:Injector,  private templateRef: TemplateRef<any>, private viewContainer: ViewContainerRef) {
    }

    ngOnInit(): void {
        //effect kan ikke kalles i konstruktør da input feltene ikke enda har fått verdier
        effect(() => {
            const harTilgang = this.harTilgang(this.rolle(), this.gruppeId());
            debug(`har tilgangsrolle '${this.rolle()}' i gruppe ${this.gruppeId()} = ${harTilgang}`)

            if (harTilgang && !this.viewOpprettet) {
                //debug('viser element')
                this.viewContainer.createEmbeddedView(this.templateRef).detectChanges();
                this.viewOpprettet = true;
            } else if(!harTilgang && this.viewOpprettet) {
                //debug('skjuler element')
                this.viewContainer.clear();
            }
        }, {injector:this.injector}); //angir injector da injectionContext ikke er tilgjengelig ved ngOnInit
    }

    // private hjelpemetoder

    private harTilgang(rollenavn: TilgangsrolleMedlemNavn, gruppeId: GruppeId) {
        const tilgangsrolle = enumInnslag<TilgangsrolleMedlem>(rollenavn, TilgangsrolleMedlem);
        return this.kontekst.autentisertBrukerSomSignal()!.inneharTilgangsrolleIGruppe(tilgangsrolle, gruppeId);
    }
}

export default KreverTilgangsrolleGruppeDirektiv
